'use strict';

module.exports = /* @ngInject */ function ($resource, apiConfig) {

	return {
		getCatalogs:
			$resource(
				apiConfig.$get().apiUrl + '/unite/shops?customer=:customer&supplier=:supplier',
				{
					customer: '@customer',
					supplier: '@supplier'
				}
			),
		getCatalogInfo:
			$resource(
				apiConfig.$get().apiUrl + '/unite/details?customer=:customer&supplier=:supplier&businessShopId=:businessShopId',
				{
					customer: '@customer',
					supplier: '@supplier',
					businessShopId: '@businessShopId'
				}
			)
	}
}
